var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlackPersonIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5007 7.24992C15.8298 7.24992 16.9173 8.33742 16.9173 9.66658C16.9173 10.9958 15.8298 12.0833 14.5007 12.0833C13.1715 12.0833 12.084 10.9958 12.084 9.66658C12.084 8.33742 13.1715 7.24992 14.5007 7.24992ZM14.5007 19.3333C17.7632 19.3333 21.509 20.892 21.7507 21.7499H7.25065C7.52857 20.8799 11.2502 19.3333 14.5007 19.3333ZM14.5007 4.83325C11.8302 4.83325 9.66732 6.99617 9.66732 9.66658C9.66732 12.337 11.8302 14.4999 14.5007 14.4999C17.1711 14.4999 19.334 12.337 19.334 9.66658C19.334 6.99617 17.1711 4.83325 14.5007 4.83325ZM14.5007 16.9166C11.2744 16.9166 4.83398 18.5358 4.83398 21.7499V24.1666H24.1673V21.7499C24.1673 18.5358 17.7269 16.9166 14.5007 16.9166Z",
    fill: "black",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackPersonIcon);
export default __webpack_public_path__ + "static/media/black-person-icon.d40ca2b43a4aae353b8657ad88088135.svg";
export { ForwardRef as ReactComponent };